const auditConditionEnum = {
  "1": "Touched Frontline Ready",
  "2": "Touched Not Frontline Ready",
  "3": "Touched Non Compliant Unit",
  "4": "Not Touched",
}

export default auditConditionEnum
